var FUN_LIST = [
  // 待办事项
  {
    id: 1,
    label: '当前故障',
    permissions: "deviceMonitorList",
    type: ['event', 'fun'],
    url: 'deviceMonitor.html#maint',
    active: '4-1',
  },
  {
    id: 2,
    label: '微信客服',
    permissions: "wechatFeedbackInfo",
    type: ['event', 'fun'],
    url: 'feedback.html',
    active: '6-6',
  },
  {
    id: 3,
    label: '钱包退款受理',
    permissions: "refundInfo",
    type: ['event', 'fun'],
    url: 'walletRefundAccept.html',
    active: '9-3',
  },
  {
    id: 4,
    label: '平台账单',
    permissions: "dealerAccountInfo",
    type: ['event', 'fun'],
    url: 'selfHelpPayCost.html#platformBillings',
    active: '9-6-1',
  },
  {
    id: 5,
    label: '个人发票申请',
    permissions: "invoiceInfo",
    type: ['event', 'fun'],
    url: 'personalInvoiceApplication.html',
    active: '9-1',
  },
  {
    id: 6,
    label: '团体发票申请',
    permissions: "userGroupInfo",
    type: ['event', 'fun'],
    url: 'groupInvoiceApplication.html',
    active: '9-2',
  },
  {
    id: 7,
    label: '电源模块保养',
    permissions: "DeviceLifeStatsInfo",
    type: ['event', 'fun'],
    url: 'powerMaint.html#power',
    active: '4-2-0',
  },
  {
    id: 8,
    label: '设备寿命保养',
    permissions: "DeviceLifeStatsInfo",
    type: ['event', 'fun'],
    url: 'powerMaint.html#eq',
    active: '4-2-1',
  },
  // 常用功能
  {
    id: 9,
    label: '现有场站',
    permissions: "siteInfo",
    type: ['fun'],
    url: 'managementDepot.html',
    active: '2-1-1',
  },
  {
    id: 10,
    label: '资费模板',
    permissions: "dealerFeepolicyInfo",
    type: ['fun'],
    url: 'rates.html',
    active: '2-2-0',
  },
  {
    id: 11,
    label: '设备管理',
    permissions: "deviceMonitorList",
    type: ['fun'],
    url: 'deviceMonitor.html#eq',
    active: '2-3-1',
  },
  {
    id: 12,
    label: '全部充电订单',
    permissions: "chargeBillInfo",
    type: ['fun'],
    url: 'bill.html',
    active: '3-0',
  },
  {
    id: 13,
    label: '维保首页',
    permissions: "DeviceErrorLogInfo",
    type: ['fun'],
    url: 'maintenanceHome.html',
    active: '4-0',
  },
  {
    id: 14,
    label: '实时监控',
    permissions: "deviceMonitorChart",
    type: ['fun'],
    url: 'chargeMonitor.html',
    active: '2-0',
  },
  /* {
    id: 15,
    label: '异常充电订单',
    permissions: "chargeBillInfo",
    type: ['fun'],
    url: 'bill.html#abnormal',
  }, */
  {
    id: 16,
    label: '设备异常日志',
    permissions: "DeviceErrorLogInfo",
    type: ['fun'],
    url: 'errorLog.html',
    active: '4-5-0',
  },
  {
    id: 17,
    label: '车辆充电日志',
    permissions: "VehicleChargeLogInfo",
    type: ['fun'],
    url: 'vehicleChargingLog.html',
    active: '4-5-1',
  },
  {
    id: 18,
    label: '平台通信日志',
    permissions: "DeviceCommLogInfo",
    type: ['fun'],
    url: 'platformLog.html',
    active: '4-5-2',
  },
  {
    id: 19,
    label: '工单管理',
    permissions: "workFlowInfo",
    type: ['fun'],
    url: 'orderManagement.html',
    active: '4-4-0',
  },
  {
    id: 20,
    label: '用户管理',
    permissions: "wechatUserInfo",
    type: ['fun'],
    url: 'user.html',
    active: '6-1-0',
  },
  {
    id: 21,
    label: '用户分类',
    permissions: "userClassInfo",
    type: ['fun'],
    url: 'userClassification.html',
    active: '6-1-2',
  },
  /* {
    id: 22,
    label: '分类管理',
    permissions: "userClassInfo",
    type: ['fun'],
    url: 'userClassList.html',
  }, */
  {
    id: 23,
    label: '等级会员',
    permissions: "userGradeInfo",
    type: ['fun'],
    url: 'member.html',
    active: '6-2-0',
  },
  {
    id: 24,
    label: '特权会员',
    permissions: "userGradeInfo",
    type: ['fun'],
    url: 'privilegedMember.html',
    active: '6-2-1',
  },
  {
    id: 25,
    label: '团体管理',
    permissions: "userGroupInfo",
    type: ['fun'],
    url: 'group.html',
    active: '6-3',
  },
  {
    id: 26,
    label: '卡组管理',
    permissions: "nfcgroupInfo",
    type: ['fun'],
    url: 'chargeCard.html',
    active: '6-4-0',
  },
  {
    id: 27,
    label: '充电卡管理',
    permissions: "nfcgroupInfo",
    type: ['fun'],
    url: 'managementCharger.html#U3',
    active: '6-4-1',
  },
  {
    id: 28,
    label: '抵用券',
    permissions: "couponTemplateInfo",
    type: ['fun'],
    url: 'coupon.html#dy',
    active: '7-1-0',
  },
  {
    id: 29,
    label: '折扣券',
    permissions: "couponTemplateInfo",
    type: ['fun'],
    url: 'coupon.html#zk',
    active: '7-1-1',
  },
  {
    id: 30,
    label: '代金券',
    permissions: "discountPackageInfo",
    type: ['fun'],
    url: 'cashCoupon.html#dj',
    active: '7-1-2',
  },
  {
    id: 31,
    label: '电量包',
    permissions: "discountPackageInfo",
    type: ['fun'],
    url: 'cashCoupon.html#dl',
    active: '7-1-3',
  },
  {
    id: 32,
    label: '活动总览',
    permissions: "promotionInfo",
    type: ['fun'],
    url: 'activityOverview.html',
    active: '7-2-0',
  },
  {
    id: 33,
    label: '储值送返活动',
    permissions: "promotionInfo",
    type: ['fun'],
    url: 'storedValueActivity.html#value',
    active: '7-2-1',
  },
  {
    id: 34,
    label: '自由领取活动',
    permissions: "promotionInfo",
    type: ['fun'],
    url: 'storedValueActivity.html#free',
    active: '7-2-2',
  },
  {
    id: 50,
    label: '充电送返活动',
    permissions: "promotionInfo",
    type: ['fun'],
    url: 'storedValueActivity.html#charge',
    active: '7-2-3',
  },
  {
    id: 35,
    label: '组队打榜活动',
    permissions: "teamRankingInfo",
    type: ['fun'],
    url: 'teamPlaylistActivity.html',
    active: '7-2-4',
  },
  {
    id: 51,
    label: '销售优惠券活动',
    permissions: "promotionInfo",
    type: ['fun'],
    url: 'storedValueActivity.html#sell',
    active: '7-2-5',
  },
  {
    id: 36,
    label: '财务概况',
    permissions: "invoiceInfo",
    type: ['fun'],
    url: 'financialHome.html',
    active: '9-0',
  },
  {
    id: 37,
    label: '充值金额统计',
    permissions: "settleInfo",
    type: ['fun'],
    url: 'monthlyStatistics.html#recharge',
    active: '9-4-0',
  },
  {
    id: 38,
    label: '退款金额统计',
    permissions: "refundInfo",
    type: ['fun'],
    url: 'monthlyStatistics.html#refund',
    active: '9-4-1',
  },
  {
    id: 39,
    label: '用户钱包余额',
    permissions: "settleInfo",
    type: ['fun'],
    url: 'monthlyStatistics.html#wallet',
    active: '9-4-2',
  },
  {
    id: 40,
    label: '站点利用率分析',
    permissions: "biInfo",
    type: ['fun'],
    url: 'analyzeXcharge.html#site',
    active: '8-1-1',
  },
  {
    id: 41,
    label: '高峰时刻分析',
    permissions: "biInfo",
    type: ['fun'],
    url: 'analyzeXcharge.html#date',
    active: '8-1-3',
  },
  {
    id: 42,
    label: '站点充电量分析',
    permissions: "biInfo",
    type: ['fun'],
    url: 'analyzeCharge.html#site',
    active: '8-2-1',
  },
  {
    id: 43,
    label: '用户来源充电量分析',
    permissions: "biInfo",
    type: ['fun'],
    url: 'analyzeCharge.html#user',
    active: '8-2-3',
  },
  {
    id: 44,
    label: '站点收入分析',
    permissions: "biInfo",
    type: ['fun'],
    url: 'analyzeIncome.html#site',
    active: '8-3-1',
  },
  {
    id: 45,
    label: '用户来源收入分析',
    permissions: "biInfo",
    type: ['fun'],
    url: 'analyzeIncome.html#user',
    active: '8-3-3',
  },
  {
    id: 46,
    label: '站点用户数分析',
    permissions: "biInfo",
    type: ['fun'],
    url: 'analyzeUser.html#site',
    active: '8-4-1',
  },
  {
    id: 47,
    label: '用户来源订单数分析',
    permissions: "biInfo",
    type: ['fun'],
    url: 'analyzeUser.html#user',
    active: '8-4-2',
  },
  {
    id: 48,
    label: '用户贡献分析',
    permissions: "biInfo",
    type: ['fun'],
    url: 'analyzeUser.html#contribution',
    active: '8-4-3',
  },
  {
    id: 49,
    label: '卡券消耗分析',
    permissions: "couponTemplateInfo",
    type: ['fun'],
    url: 'cardAnalysis.html#card',
    active: '8-5',
  },
]
module.exports = FUN_LIST;